import { AuthorizationGuard } from 'auth/auth-components/AuthorizationGuard';
import { ScrollToTop } from 'components/atoms/scroll-to-top/ScrollToTop';
import { Outlet } from 'react-router-dom';

export const AuthenticatedRoute = () => (
  <AuthorizationGuard>
    <ScrollToTop />
    <Outlet />
  </AuthorizationGuard>
);
